/**
 * 历史记录页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const historyCommonConfig = {
  texts: {
    noData: 'No data available',
    goToNovel: 'Go to Novel',
    viewed: 'Viewed',
    completed: 'Completed',
    ongoing: 'Ongoing',
    lastRead: 'Last read',
    noMore: 'no more ，let\'s find the next good book.',
    loading: 'Loading...',
    bookRemoved: 'Sorry, But the book has been removed!',
  },
}
